"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _react = _interopRequireWildcard(require("react"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _handleLanguageCharacters = require("@deosite/helpers/handleLanguageCharacters");
var _replaceSpecialCharacters = _interopRequireDefault(require("@deosite/helpers/replaceSpecialCharacters"));
var _useAppConfiguration2 = _interopRequireDefault(require("@deosite/hooks/useAppConfiguration"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var QuestionIcon = function QuestionIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fill: "none",
    d: "M58.49 50.009c-4.677 0-8.481 3.804-8.481 8.481 0 4.676 3.805 8.48 8.481 8.48 4.678 0 8.481-3.805 8.481-8.48 0-4.677-3.803-8.481-8.481-8.481z"
  }), __jsx("path", {
    fill: "#2F4658",
    d: "M58.49 48.554c-5.479 0-9.936 4.458-9.936 9.936 0 5.479 4.457 9.936 9.936 9.936s9.936-4.456 9.936-9.936c0-5.479-4.457-9.936-9.936-9.936zm0 18.416c-4.677 0-8.481-3.805-8.481-8.48 0-4.677 3.805-8.481 8.481-8.481 4.678 0 8.481 3.804 8.481 8.481 0 4.675-3.803 8.48-8.481 8.48z"
  }), __jsx("path", {
    fill: "#2F4658",
    d: "M57.188 60.381c0-.278.038-.526.114-.744.076-.218.197-.425.365-.618a4.31 4.31 0 0 1 .693-.591 6.83 6.83 0 0 0 .605-.491c.159-.144.272-.286.341-.43.076-.143.114-.302.114-.478 0-.269-.102-.471-.304-.604-.193-.144-.466-.214-.82-.214a3.41 3.41 0 0 0-1.045.164 6.933 6.933 0 0 0-1.059.44l-.668-1.348a6.834 6.834 0 0 1 1.336-.555 5.483 5.483 0 0 1 1.575-.215c.874 0 1.549.21 2.029.63.487.42.73.954.73 1.601 0 .344-.056.642-.165.895a2.271 2.271 0 0 1-.491.706c-.218.21-.491.436-.818.68a6.282 6.282 0 0 0-.567.453 1.1 1.1 0 0 0-.276.366 1.318 1.318 0 0 0-.063.44v.365h-1.625l-.001-.452zm-.201 2.558c0-.386.104-.654.315-.807.21-.158.467-.239.769-.239.294 0 .546.081.756.239.211.152.314.421.314.807 0 .369-.104.638-.314.806a1.21 1.21 0 0 1-.756.239c-.302 0-.559-.079-.769-.239-.21-.169-.315-.437-.315-.806z"
  }));
};
QuestionIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "48.49 48.49 20 20"
};
var CollectionButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _producer$name, _producer, _producer2, _producer3, _global$__appConfig__, _global$__appConfig__2, _global$__appConfig__3;
  var product = _ref.product,
    setShowProducent = _ref.setShowProducent,
    _ref$isCollection = _ref.isCollection,
    isCollection = _ref$isCollection === void 0 ? true : _ref$isCollection,
    _ref$rootCategory = _ref.rootCategory,
    rootCategory = _ref$rootCategory === void 0 ? "/" : _ref$rootCategory,
    _ref$brandCategory = _ref.brandCategory,
    brandCategory = _ref$brandCategory === void 0 ? "/" : _ref$brandCategory;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language;
  var buttonStyles = {
    display: "flex",
    height: "100%",
    bg: "beige",
    px: "s6",
    // py: 10,
    ml: "s4",
    borderRadius: 5,
    cursor: "pointer",
    alignItems: "center",
    justifyContent: "space-between"
  };
  var producer = product.producer,
    collection = product.collection;
  producer = typeof producer === "string" ? producer : (_producer$name = (_producer = producer) === null || _producer === void 0 ? void 0 : _producer.name) !== null && _producer$name !== void 0 ? _producer$name : "";
  var collectionName = (collection === null || collection === void 0 ? void 0 : collection.name) && (0, _handleLanguageCharacters.removeSpecificCharactersFromString)({
    string: collection.name.toLowerCase().replace(/\s/g, "_").replace(/\//g, "_").replace(/&/g, "_").replace(/(_)\1+/g, "_")
  });
  var collectionUrls = {
    collection: producer ? "".concat(rootCategory, "/").concat((0, _handleLanguageCharacters.removeSpecificCharactersFromString)({
      string: (_producer2 = producer) === null || _producer2 === void 0 ? void 0 : _producer2.toLowerCase(),
      removeSpaces: true
    }), "-").concat(collectionName) : "".concat(rootCategory, "/").concat((0, _handleLanguageCharacters.removeSpecificCharactersFromString)({
      string: collection === null || collection === void 0 ? void 0 : collection.name,
      removeSpaces: true
    }).toLowerCase()),
    producer: "".concat(rootCategory).concat(brandCategory, "/").concat((0, _handleLanguageCharacters.removeSpecificCharactersFromString)({
      string: (_producer3 = producer) === null || _producer3 === void 0 ? void 0 : _producer3.toLowerCase(),
      removeSpaces: true,
      spaceChar: "-"
    }))
  };
  var label = isCollection ? collection === null || collection === void 0 ? void 0 : collection.name : producer;
  var producerData = !isCollection && ((_global$__appConfig__ = (_global$__appConfig__2 = global.__appConfig__.producers[language]) === null || _global$__appConfig__2 === void 0 ? void 0 : _global$__appConfig__2[producer.toLowerCase()]) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : (_global$__appConfig__3 = global.__appConfig__.producers[language]) === null || _global$__appConfig__3 === void 0 ? void 0 : _global$__appConfig__3["dajar"]);
  return __jsx(_Box["default"], {
    sx: buttonStyles,
    ref: ref
  }, __jsx(Link, {
    href: isCollection ? (0, _replaceSpecialCharacters["default"])(collectionUrls.collection) : (0, _replaceSpecialCharacters["default"])(collectionUrls.producer)
  }, __jsx(_LinkRaw["default"], {
    title: label
  }, label)), producerData && __jsx(_Box["default"], {
    as: "span",
    sx: {
      height: 22,
      marginLeft: 5
    },
    onClick: function onClick() {
      return setShowProducent(_objectSpread(_objectSpread({}, producerData), {}, {
        producer: producer
      }));
    }
  }, __jsx(QuestionIcon, null)));
});
var _default = CollectionButton;
exports["default"] = _default;